import BackendService from './BackendService';

async function getOnlineOrders(params = {}) {
 return BackendService.get('/online-orders/', {}, params);
}

async function getOnlineOrderDetails(orderId) {
  return BackendService.getData(`/online-orders/${orderId}/`);
}

async function updateOrder(orderId, data) {
  return BackendService.patch(`/online-orders/${orderId}/`, data);
}

async function getCustomerPayments(params = {}){
  return BackendService.get('/customer-payments/', {}, params);
}

async function getCustomerPaymentDetails(paymentId) {
  return BackendService.get(`/customer-payments/${paymentId}/`);
}

async function processRefund(paymentId) {
  return BackendService.post(`/customer-payments/${paymentId}/refund/`);
}

const OnlineOrderService = {
  getOnlineOrders,
  getOnlineOrderDetails,
  updateOrder,
  getCustomerPayments,
  getCustomerPaymentDetails,
  processRefund,
};

export default OnlineOrderService;
